import React, { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { LeftOutline, RightOutline } from 'antd-mobile-icons'
import './czService.css'
import { useTranslation } from "react-i18next";
import { getService } from '../request/api'
import { initCrmChat } from '../plugins/crmChat';

export default function CzService() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [isTx, setIsTx] = useState(false)
    const [serviceUrl, setServiceUrl] = useState('')
    const crmRef = useRef(null)

    useEffect(() => {
        const w = new URLSearchParams(location.search).get('w');
        const open = new URLSearchParams(location.search).get('open');
        if (w === '1') {
            setIsTx(true)
        }
        if (open === 'true') {
            getService({}).then((res) => {
                if (res.code == 1) {
                    setServiceUrl(res.data)
                }
            });
        }
    }, [])

    useEffect(() => {
        if (serviceUrl) {
            openChat(serviceUrl)
        }
    }, [serviceUrl])

    const openChat = async (service) => {
        try {
            if (!crmRef.current) {
                crmRef.current = await initCrmChat(service);
            }
            crmRef.current.getCustomeServer();
        } catch (err) {
            console.error('error', err);
        }
    }

    const handleClick = async () => {
        if (!serviceUrl) {
            const res = await getService({});
            if (res.code == 1) {
                setServiceUrl(res.data)
                await openChat(res.data);
            }
        } else {
            await openChat(serviceUrl);
        }
    }

    useEffect(() => {
        return () => {
            if (crmRef.current) {
                crmRef.current.destroy();
            }
        }
    }, [])

    const nodeFun = () => { }
    nodeFun()
    return (
        <div className='czService_page'>
            <div className='header'>
                <div className='backIcon' onClick={() => { navigate(-1) }}>
                    <LeftOutline />
                </div>
                {isTx?(<p>{t('kf2')}</p>):
                (<p>{t('kf4')}</p>)}
            </div>
            <div className='content' id="kefu">
                <div className='container2'>
                    <div className='createChat' onClick={handleClick}>
                        {isTx ? (
                            <div className='left-info'>
                                <div className='card_title'>{t('kf2')}</div>
                                <div className='remark'>{t('kf3')}</div>
                            </div>
                        ) : (
                            <div className='left-info'>
                                <div className='card_title'>{t('kf4')}</div>
                                <div className='remark'>{t('kf5')}</div>
                            </div>
                        )}
                        <RightOutline className='icon' />
                    </div>
                </div>
            </div>
        </div>
    )
}
